import { getFarmartAIBaseUrl } from './api-base-url';

export const APIS = {
	CHAT_HISTORY_ITEM: 'chat_history/v2', // with chat id
	CHAT_HISTORY_LIST: 'chat_history/v2',
	DYNAMIC_PROMPTS: 'dynamic_homepage_prompts/v2',
	UPDATE_USER_META: 'user/metadata/v1/update',
	STREAM: 'chat/v1/stream',
	REGISTER_SESSION: 'register_session/v1',
	EXTERNAL_COMMUNITY_PROMPTS_SUMMARY:
		'retailer_community/v1/post/prompts_and_summary',
	UPLOAD_MEDIA: 'media/v1/upload',
};

export function getStreamUrl(): string {
	return `${getFarmartAIBaseUrl()}/${APIS.STREAM}`;
}
